import { endpoints } from '@/react-query/endpoints';

import type {
  FetchVideaImageIdResponse,
  FetchVideaPatientIdResponse,
} from '../../@types/contracts';
import { makeAPIRequestReactQuery } from '../../react-query/api';
import { makeAPIRequestV2 } from '../../utils/api';

export const fetchVideaPatientId = async (
  practicePatientId: any,
  primaryPracticeId: any,
  estimatedVisitId?: number,
) => {
  return makeAPIRequestReactQuery<FetchVideaPatientIdResponse>(
    `/${endpoints.patient}/${endpoints.getVideaPatientId}`,
    {
      practicePatientId,
      practiceId: primaryPracticeId,
      estimatedVisitId,
    },
  );
};

export const fetchVideaImageId = async (
  practicePatientId: any,
  primaryPracticeId: any,
  primaryOrganizationId: any,
  practiceImageId: any,
) => {
  let response: { data: FetchVideaImageIdResponse } | null = null;
  response = await makeAPIRequestV2(
    `/${endpoints.patient}/${endpoints.getVideaImageId}?organizationId=${primaryOrganizationId}&practicePatientId=${practicePatientId}&practiceId=${primaryPracticeId}&practiceImageId=${practiceImageId}`,
  );
  return response.data;
};
